import React, { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { AppError } from "@src/components";

const AppErrorPage = () => {
  const error = useRouteError();

  useEffect(() => {
    console.log("Router error ::", error);
  }, [error]);

  return <AppError />;
};

export { AppErrorPage };
